var $360057ace2262932$exports = {};
$360057ace2262932$exports = {
    "collectionLabel": `\u{5D4}\u{5E6}\u{5E2}\u{5D5}\u{5EA}`
};


export {$360057ace2262932$exports as default};
//# sourceMappingURL=he-IL.mjs.map
